export default "__VITE_ASSET__DTk0_Vh$__"